import React, { useRef, useContext, useEffect, useState } from 'react';

import { ModalContext } from '$contexts/modal.jsx';
import { useCursorContext } from '$contexts/cursor.jsx';
import { ArrowRightIcon } from '$partials/icon';
import { Button, Checkbox } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modals.d.ts').MultiSelectModal}
 */
const MultiSelectModal = ({
    selected = [],
    options = [],
    onComplete = () => {},
    title,
    buttonLabel
}) => {

    const { handleModal } = useContext(ModalContext);
    const { dispatch: cursorDispatch } = useCursorContext();
    const exitButtonRef = useRef(null);
    const [ selectedOptions, setSelectedOptions ] = useState(selected);


    useEffect(() => {
        const exit = cursorDispatch({
            type: 'registerArea',
            data: {
                ref: exitButtonRef,
                cursorType: 'exit'
            },
        });

        return () => [exit].map(cleanup => {
            cleanup();});
    }, []);


    return (
        <>
            <div
                className={'fixed left-0 top-0 height-100 width-100 border-0 m0 p0 overflow-hidden bg-black mix-blend-multiply z3 cursor-none'}
                onClick={() => {
                    handleModal();
                }}
                ref={exitButtonRef}
                style={{opacity: '0.2'}}>
            </div>
            <div
                className='bg-white z5 fixed overflow-auto modal-container floating-container'>
                {/* Checkboxes */}
                <div className='col-12 p6'>
                    <p className='type-style-5'>{title}</p>
                    <div className='pt4 flex flex-wrap'>
                        {options?.map((item) => {
                            return (
                                <div key={item.value}>
                                    <Checkbox
                                        checked={selectedOptions.includes(item.value)}
                                        label={item.label}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedOptions([...selectedOptions, e.target.value]);
                                            } else {
                                                setSelectedOptions(selectedOptions.filter(option => option !== e.target.value));
                                            }
                                        }}
                                        value={item.value} />
                                </div>
                            );
                        })}
                    </div>
                </div>

                <Button
                    aria-label='Submit'
                    as='button'
                    className = 'bg-black white type-style-5 items-center'
                    look = 'fill'
                    // disabled={isLoading}
                    onClick={() => {
                        onComplete(selectedOptions);
                        handleModal();
                    }}
                    renderIcon={<ArrowRightIcon />}
                    type='submit'>
                    {buttonLabel}
                </Button>
            </div>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

export default MultiSelectModal;
